import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Attachment } from '../entities/attachment';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DirectoryItem } from '../model/directory-item';

@Injectable()
export class AttachmentService extends BaseCrudService<Attachment> {

  uri = '/api/attachment/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance AbsenceLeaveAttachService');
  }

  buildSentence(entity?: Attachment, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      /*query = query.concat(
        entity && entity.fileName ?
          `fileName${QueryOperator.Contain}${entity.fileName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.masterTable ?
          `masterTable${QueryOperator.Equal}${entity.masterTable}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.table ?
          `table${QueryOperator.Equal}${entity.table}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && (entity.flgPicture!=undefined) ?
          `flgPicture${QueryOperator.Equal}${entity.flgPicture}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity && (entity.flgStatus!=undefined) ?
          `flgStatus${QueryOperator.Equal}${entity.flgStatus}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); */
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  /*dowloadAttachment(entity?: EmployeeAttach): Observable<Blob> {
    const url = `${this.rutaServidor}${this.uri}${entity.id}/download-attachment`;
    this.spinnerService.showAll();
    return this.httpClient.get(url, { responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttachment');
          //console.log(response);
          this.spinnerService.hideAll();
        })
      );
  }*/

  /*getProfilePicture(entity?: EmployeeAttach): Observable<Blob> {
    const url = `${this.rutaServidor}${this.uri}getProfilePicture`;
    //his.spinnerService.showAll();
    return this.httpClient.post(url,entity, { responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttachment');
           //console.log(response);
          this.spinnerService.hideAll();
        })
      );
  }*/

  /*
  getProfilePictureUser(entity?: EmployeeAttach): Observable<Blob> {
    let rutaServidor =  environment.apiUrl + '8080/adminAuthModule'; 
    //let rutaServidor =  environment.apiUrl + '/adminAuthModule';
    let url = `${rutaServidor}${this.uri}getProfilePictureUser`;
    //his.spinnerService.showAll();
    return this.httpClient.post(url,entity, { responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttachment');
           //console.log(response);
          this.spinnerService.hideAll();
        })
      );
  }*/

  uploadFile(pathFile : DirectoryItem, files: File[]): Observable<any>{
    const url = `${this.rutaServidor}${this.uri}uploadFile`;
    const uploadData = new FormData(); 
  
    uploadData.append('info', new Blob([JSON.stringify(pathFile)], {
      type: "application/json"
  }))
    //console.log(uploadData);
    if (files) {
      files.forEach((file) => {
        uploadData.append('file', file, file.name);
      })
    }

    this.spinnerService.showAll();
    return this.httpClient.post<any>(url, uploadData)
      .pipe(
        tap(response => {
            if (response.numberOfElements > 0) {
              //console.log(response);
              response.content.forEach((value) => {
                  // this.convertToDate(value);
              })
            }
            this.spinnerService.hideAll();
            return response;
        })
      );
  }
 
  getDataFTP(path : DirectoryItem):Observable<any>{
    const url = `${this.rutaServidor}${this.uri}getDataFTP`;
    this.spinnerService.showAll();
    return this.httpClient.post<DirectoryItem>(url,path)
    .pipe(
      tap(response => {
          if (response.numberOfElements > 0) {
            //console.log(response);
            response.content.forEach((value) => {
                // this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
      })
    );
  }


  createFolder(path : DirectoryItem):Observable<any>{
    const url = `${this.rutaServidor}${this.uri}createFolder`;
    this.spinnerService.showAll();
    return this.httpClient.post<DirectoryItem>(url,path)
    .pipe(
      tap(response => {
          if (response.numberOfElements > 0) {
            //console.log(response);
            response.content.forEach((value) => {
                // this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
      })
    );
  }

  downloadFile(item:DirectoryItem): Observable<Blob> {
    const url = `${this.rutaServidor}${this.uri}downloadFile`;
    this.spinnerService.showAll();
    return this.httpClient.post(url, item,{ responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttachment');
          //console.log(response);
          this.spinnerService.hideAll();
        })
      );
  }

  deleteFile(path : DirectoryItem):Observable<any>{
    const url = `${this.rutaServidor}${this.uri}deleteFile`;
    this.spinnerService.showAll();
    return this.httpClient.post<DirectoryItem>(url,path)
    .pipe(
      tap(response => {
          if (response.numberOfElements > 0) {
            //console.log(response);
            response.content.forEach((value) => {
                // this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
      })
    );
  }

  editNameItem(path : DirectoryItem):Observable<any>{
    const url = `${this.rutaServidor}${this.uri}editNameItem`;
    this.spinnerService.showAll();
    return this.httpClient.post<DirectoryItem>(url,path)
    .pipe(
      tap(response => {
          if (response.numberOfElements > 0) {
            //console.log(response);
            response.content.forEach((value) => {
                // this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
      })
    );
  }

  moveItem(path : DirectoryItem):Observable<any>{
    const url = `${this.rutaServidor}${this.uri}moveItem`;
    this.spinnerService.showAll();
    return this.httpClient.post<DirectoryItem>(url,path)
    .pipe(
      tap(response => {
          if (response.numberOfElements > 0) {
            //console.log(response);
            response.content.forEach((value) => {
                // this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
      })
    );
  }
}
 



// WEBPACK FOOTER //
// ./src/app/core/services/attachment.service.ts